import React from "react";
import PropTypes from "prop-types";
import CurrencyFacets from "./CurrencyFacets";
import SpendingRow from "./SpendingRow";
import { CurrencyChip, FacetHeader, FacetWrapper } from "./layout";

function CurrencyTopSpendings({ currencyName, rows }) {
  return (
    <FacetWrapper>
      <FacetHeader>
        <CurrencyChip>{currencyName}</CurrencyChip>
      </FacetHeader>
      {rows.map((spending) => (
        <SpendingRow key={spending.id} spending={spending} />
      ))}
    </FacetWrapper>
  );
}

CurrencyTopSpendings.propTypes = {
  currencyName: PropTypes.string.isRequired,
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default function TopSpendingsList({ topSpendings }) {
  return (
    <CurrencyFacets rows={topSpendings}>
      {(currency, rows) => (
        <CurrencyTopSpendings key={currency.id} currencyName={currency.name} rows={rows} />
      )}
    </CurrencyFacets>
  );
}

TopSpendingsList.propTypes = {
  topSpendings: PropTypes.arrayOf(PropTypes.object),
};

TopSpendingsList.defaultProps = {
  topSpendings: null,
};
